// extracted by mini-css-extract-plugin
export default {"emptyListWrapper":"Htrh0DB6RC6as61VpbM2"};